var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1895 13.6949V6.3043C17.1889 6.19303 17.1589 6.08388 17.1027 5.98787C17.0465 5.89186 16.9659 5.81237 16.8691 5.75742L10.3066 2.04648C10.214 1.993 10.1089 1.96484 10.002 1.96484C9.89499 1.96484 9.7899 1.993 9.69727 2.04648L3.13477 5.75742C3.03801 5.81237 2.95745 5.89186 2.90121 5.98787C2.84498 6.08388 2.81505 6.19303 2.81445 6.3043V13.6949C2.81505 13.8062 2.84498 13.9153 2.90121 14.0114C2.95745 14.1074 3.03801 14.1869 3.13477 14.2418L9.69727 17.9527C9.7899 18.0062 9.89499 18.0344 10.002 18.0344C10.1089 18.0344 10.214 18.0062 10.3066 17.9527L16.8691 14.2418C16.9659 14.1869 17.0465 14.1074 17.1027 14.0114C17.1589 13.9153 17.1889 13.8062 17.1895 13.6949V13.6949Z",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagon);
export default __webpack_public_path__ + "static/media/hexagon.7d18b9b2bf70e088b679371b650498fe.svg";
export { ForwardRef as ReactComponent };